import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "components/ui/Header";
import LandingPage from "pages/landing-page";
import JobSeekerRegistrationLogin from "pages/job-seeker-registration-login";
import JobDetailApplication from "pages/job-detail-application";
import JobSearchBrowse from "pages/job-search-browse";
import JobSeekerDashboard from "pages/job-seeker-dashboard";
import RecruiterDashboardAnalytics from "pages/recruiter-dashboard-analytics";
import CompanyRegistrationProfileSetup from "pages/company-registration-profile-setup";
import JobPostingCreationManagement from "pages/job-posting-creation-management";
import AdminModerationManagement from "pages/admin-moderation-management";
import PrivateVideo from "pages/PrivateVideo";
import NotFound from "pages/NotFound";
import SocialFooter from "components/ui/SocialFooter";

const Routes = () => {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <Header />
      <RouterRoutes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/job-seeker-registration-login" element={<JobSeekerRegistrationLogin />} />
        <Route path="/job-detail-application" element={<Navigate to="/job-search-browse" replace />} />
        <Route path="/job-detail-application/:id" element={<JobDetailApplication />} />
        <Route path="/job-search-browse" element={<JobSearchBrowse />} />
        <Route path="/job-seeker-dashboard" element={<JobSeekerDashboard />} />
        <Route path="/recruiter-dashboard-analytics" element={<RecruiterDashboardAnalytics />} />
        <Route path="/company-registration-profile-setup" element={<CompanyRegistrationProfileSetup />} />
        <Route path="/job-posting-creation-management" element={<JobPostingCreationManagement />} />
        <Route path="/admin-moderation-management" element={<AdminModerationManagement />} />
        <Route path="/shared-video/:videoId" element={<PrivateVideo />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      <SocialFooter />
    </ErrorBoundary>
  );
};

export default Routes;